export default /* glsl */ `
  uniform sampler2D uTexture;
  uniform vec3 uColor0;
  uniform vec3 uColor1;
  uniform vec3 uDotColor;
  uniform float uDotOpacity;
  uniform vec4 uProgress;
  uniform vec3 uBgColor;
  varying vec2 vUv;

  float parabola(float x, float k) {
    return pow(4.0 * x * (1.0 - x), k);
  }

  void main(){
    vec3 data = texture2D(uTexture, vUv).rgb;
    float grayscale = data.r;
    float fadein = data.g;

    vec3 gradient = mix(uColor0, uColor1, smoothstep(0.0, 1.5 + (1.0 - uProgress.x) * 4.0, vUv.y));
    vec3 color = mix(gradient, uDotColor + vUv.y, grayscale * smoothstep(0.9, 0.0, vUv.y) * uProgress.z * uDotOpacity);

    // Correct for gamma
    color = pow(color, 1.0 / vec3(2.2));

    color = mix(uBgColor, color, (uProgress.x * uProgress.x));

    gl_FragColor = vec4(color, 1.0);
  }
`
